import type { NavigateFunction } from 'react-router-dom';
import type { AppGuideNavHint, AppGuideScreen } from '@lighthouse/shared';

const TAB_PATHS: Partial<Record<AppGuideScreen, string>> = {
  HomeTab: '/dashboard',
  TherapyTab: '/dashboard',
  ToolsTab: '/tools',
  ProfileTab: '/profile',
};

const STACK_PATHS: Partial<Record<AppGuideScreen, string>> = {
  TherapistList: '/therapists',
  Assessment: '/assessment',
  Progress: '/progress',
  Journal: '/journal',
  Activities: '/activities',
  Learn: '/learn',
  Badges: '/badges',
  GroupSessions: '/groups',
  Referral: '/referrals',
  Notifications: '/profile',
  CrisisSupport: '/tools/crisis',
  Grounding: '/tools/grounding',
  SessionPrep: '/tools/session-prep',
  WorryDump: '/tools/worry-dump',
  AppGuide: '/tools/guide',
};

export function navigateFromAppGuide(navigate: NavigateFunction, hint: AppGuideNavHint): void {
  const { screen, params } = hint;

  const tabPath = TAB_PATHS[screen];
  if (tabPath) {
    navigate(tabPath);
    return;
  }

  if (screen === 'ActivityTimer') {
    navigate(`/activities/${params?.slug ?? 'box-breathing'}`);
    return;
  }

  const stackPath = STACK_PATHS[screen];
  if (stackPath) {
    navigate(stackPath);
  }
}
